import { useQuery } from "@apollo/client/react";
import GET_RECIPIENT_APPROVAL_PREVIEW from "../../queries/email/getRecipientApprovalPreview";

interface Response {
  email?: {
    recipientApprovalPreview?: {
      htmlContent?: string;
    };
  };
}

export const useRecipientApprovalPreview = (message: string, skip?: boolean) => {
  const { data, error, loading } = useQuery<Response>(
    GET_RECIPIENT_APPROVAL_PREVIEW,
    {
      variables: { message },
      skip: skip || !message,
    }
  );
  return {
    htmlContent: data?.email?.recipientApprovalPreview?.htmlContent ?? null,
    error,
    loading,
  };
};
